import * as styles from "./PanelFooter.css";

import { clsx } from "clsx";
import { type ReactNode } from "react";

type PanelFooterProps = {
  children?: ReactNode;
  className?: string;
};

export function PanelFooter({ children, className }: PanelFooterProps) {
  return <div className={clsx(styles.footer, className)}>{children}</div>;
}
